import { Info } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { getGrapeVarietyInfoUrl } from '../../utils/grapeVarietyUtils';

const SingleGrapeVarietyPill = ({ 
  variety, 
  country,
  region,
  appellation,
  style = {}
}) => {
  const navigate = useNavigate();

  const cleanVariety = variety.trim();
  const percentage = cleanVariety.match(/(\d+(?:\.\d+)?)\s*%/);
  const varietyName = percentage ? cleanVariety.replace(percentage[0], '').trim() : cleanVariety;
  
  const infoUrl = getGrapeVarietyInfoUrl(varietyName, country, region, appellation);
  const isClickable = !!infoUrl;

  const handleClick = () => {
    if (isClickable) {
      navigate(infoUrl);
    }
  };

  return (
    <div
      onClick={handleClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: '#fff',
        padding: '6px 12px',
        borderRadius: 20,
        border: '1px solid #e8e0e8',
        fontSize: 14,
        color: '#4B164C',
        fontWeight: 500,
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        width: 'fit-content',
        maxWidth: '100%',
        ...style
      }}
      onMouseOver={e => {
        if (isClickable) {
          e.currentTarget.style.background = '#f8f6fa';
          e.currentTarget.style.borderColor = '#4B164C';
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(75,22,76,0.15)';
        }
      }}
      onMouseOut={e => {
        if (isClickable) {
          e.currentTarget.style.background = '#fff';
          e.currentTarget.style.borderColor = '#e8e0e8';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }
      }}
      title={isClickable ? `En savoir plus sur ${varietyName}` : undefined}
    >
      <span style={{ whiteSpace: 'nowrap' }}>{varietyName}</span>
      {percentage && (
        <span style={{ 
          background: '#4B164C', 
          color: '#fff', 
          padding: '2px 6px', 
          borderRadius: 10, 
          fontSize: 12,
          fontWeight: 600,
          flexShrink: 0
        }}>
          {percentage[0]}
        </span>
      )}
      {isClickable && (
        <Info 
          size={12} 
          color="#4B164C" 
          style={{ flexShrink: 0 }}
        />
      )}
    </div>
  );
};

export const GrapeVarietyPill = ({ 
  grape, 
  country,
  region,
  appellation,
  style = {}
}) => {
  // Ensure grape is a string and handle various data types
  const grapeString = typeof grape === 'string' ? grape : String(grape || '');
  const grapeArray = grapeString ? grapeString.split(',').filter(item => item.trim()) : [];
  
  if (grapeArray.length === 0) {
    return (
      <div style={{
        background: '#fff',
        padding: '6px 12px',
        borderRadius: 20,
        border: '1px solid #e8e0e8',
        fontSize: 14,
        color: '#4B164C',
        fontWeight: 500,
        width: 'fit-content',
        ...style
      }}>
        {grapeString || 'Non spécifié'}
      </div>
    );
  }
  
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
      {grapeArray.map((variety, index) => (
        <SingleGrapeVarietyPill
          key={index}
          variety={variety}
          country={country}
          region={region}
          appellation={appellation}
          style={style}
        />
      ))}
    </div>
  );
}; 